import { render, staticRenderFns } from "./CertificatesReprint.vue?vue&type=template&id=32568460&"
import script from "./CertificatesReprint.vue?vue&type=script&lang=ts&"
export * from "./CertificatesReprint.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports